<template>
  <div class=" body" :class="showSidebar ? 'sidebar-xs' : ''" >
    <!-- :class="showSidebarMobile ? 'sidebar-xs sidebar-mobile-main' : ''" -->
    <!-- <BaseNavbar></BaseNavbar> -->

    <!-- Page content -->
    <div class="page-content">
      <BaseSidebar></BaseSidebar>

      <!-- Main content -->
      <div class="content-wrapper">
        <div style="height:80px!important;  z-index:100 !important" class="d-flex border-bottom bg-white px-3 w-100 justify-content-between align-items-center  navbar_dark ">
          <div class="navbar-brand">
            <a href="/" class="d-inline-block text-dark">
              <h3 >Welcome to , {{this.site_settings.name }}</h3>
            </a>
          </div>

          <div class="d-flex flex-row align-items-start justify-content-center">
            <!-- <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbar-mobile"
            >
              <i class="icon-tree5"></i>
            </button> -->
            <li class="nav-item dropdown dropdown-user">
              <a
                href="#"
                class="navbar-nav-link topbar-btn-balance mx-2 d-flex align-items-center dropdown-toggle"
                data-toggle="dropdown"
              >
                <img
                  src="../assets/global_assets/images/image.png"
                  class="rounded-circle mr-2"
                  height="34"
                  alt=""
                />
                <span>
                  {{ user.first_name || "" }} {{user.last_name || ""}}
                </span>
              </a>

              <div class="dropdown-menu dropdown-menu-right">
                <router-link :to="{ name: 'Profile' }" class="dropdown-item"
                  ><i class="icon-user-plus"></i> My profile</router-link>
                <router-link  :to="{ name: 'Wallet' }" class="dropdown-item"
                  ><i class="icon-coins"></i> My balance</router-link>
                <router-link :to="{ name: 'Messages' }" class="dropdown-item"><i class="icon-comment-discussion"></i> Messages
                  <!-- <span class="badge badge-pill bg-blue ml-auto">58</span> -->
                </router-link>
                <div class="dropdown-divider"></div>
              
                <a @click="doLogout" class="dropdown-item"
                  ><i class="icon-switch2"></i> Logout</a>
              </div>
            </li>
            <button @click="_toggleSidebarMobile" class="navbar-toggler mx-2 sidebar-mobile-main-toggle" type="button">
              <i class="icon-paragraph-justify3"></i>
            </button>
          </div>
          <div class="collapse navbar-collapse" id="navbar-mobile">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a
                  href="#"
                  class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
                  @click="_toggleSidebar" 
                >
                  <i class="icon-paragraph-justify3"></i>
                </a>
              </li>
            </ul>

            <ul class="navbar-nav ml-auto">
              

              
            </ul>
          </div>

          
        </div>
        
        <!-- Content area -->
        <div class="content" style="min-height: 100vh !important; ">
          <!-- <BaseLoading style="min-height: 400px; height: 90vh;" v-if="$store.state.loading"></BaseLoading> -->
          <transition name="slide-fade">
            <router-view></router-view>
          </transition>
        </div>
        <!-- /content area -->

        <!-- <BaseFooter></BaseFooter> -->
      </div>
      <!-- /main content -->
    </div>
    <!-- /page content -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState} from "vuex";
export default {
  name: "Home",

  computed: {
    ...mapState("sidebar", ["showSidebar"]),
    ...mapState("auth", ["user"]),
    ...mapState("setups", ["site_settings"]),

  },

  methods: {
    ...mapActions("auth", ["doLogout"]),
    ...mapMutations("sidebar", ["_toggleSidebar", "_toggleSidebarMobile"]),
    ...mapState("setups", ["site_settings"]),
  },
};
</script>

<style lang="scss">
// sidebar
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(40px);
  opacity: 0;
}
.content{
  background-color:#F5F9FC!important;
}
.dropdown-user {
  list-style-type: none!important;
}


.topbar-btn-balance {
  cursor: pointer;
  padding: 7px 8px;
  min-width: 194px;
  border: 1px solid #DFDFEA;
  box-sizing: border-box;
  border-radius: 50px;
  font-family: 'Gotham Pro';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #4C4C4C;
}

.navbar > .container > .show {
  background-color: #05072D!important;
  padding:18px 10px!important;
}
</style>
